import { useQuery } from '@tanstack/react-query';
import { getUserPlayRecords } from '@/services/classLabPlatformService';

export interface UsePracticeStatusOptions {
    enabled?: boolean;
}

export interface UserPlayRecordsResponse {
    classUser: {
        _id: string | null;
        user_id: string;
        class_id: string;
        class_study_started_at: number | null;
        class_study_ended_at: number | null;
    };
    classData: {
        _id: number;
        class_name: string;
        class_name_sub: string;
        customer_name: string;
        customer_list: any[];
        contents: any[];
    };
    contentsModes: Record<string, any>;
    total_page: number;
    total_count: number;
    ScenaroPlayRecords: Array<{
        user_id: string;
        class_id: string;
        class_user_id: string;
        scenario_id: string;
        content_id: string;
        content_type: string;
        content_code: string;
        content_name: string;
        mode: string;
        mode_value_title?: string;
        started_at: number;
        ended_at: number;
        play_time: number;
        score: number;
        pass: boolean;
        game_clear: boolean;
    }>;
}

/**
 * 실습현황 데이터 조회 (개별 사용자)
 * GET /class/lab/user/play-records?classId={classId}&userId={userId}
 */
export function usePracticeStatus(
    classId: number | undefined,
    userId: number | undefined,
    options?: UsePracticeStatusOptions
) {
    return useQuery<UserPlayRecordsResponse>({
        queryKey: ['practiceStatus', classId, userId],
        queryFn: async () => {
            if (!classId || !userId) throw new Error('classId and userId are required');
            const response = await getUserPlayRecords(classId, userId);
            return response as UserPlayRecordsResponse;
        },
        enabled: options?.enabled !== false && classId != null && classId > 0 && userId != null && userId > 0,
    });
}
